import $ from "jquery";

$(".toggleMenu").on("click", function(){
    $(".mobile_menu__screen").toggle();
});